import Nav from "react-bootstrap/Nav";
import { NavLink } from "react-router-dom";
import {
  FaChalkboardTeacher,
  FaHome,
  FaPuzzlePiece,
  FaCubes,
  FaTags,
  FaUsers,
  FaEdit,
  FaCheckSquare,
  FaChartBar,
  FaBuilding,
  FaBriefcase,
  FaHandsHelping,
  FaFootballBall,
  FaUserFriends,
  FaAward,
  FaBullseye,
  FaTrafficLight,
  FaLock,
} from "react-icons/fa";
import Image from "react-bootstrap/Image";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import "./MainMenu.css";
import Logo from "../../Public/sphere-logo.png";

function MainMenu({ performancePackage, strategyPackage, role }) {
  /* const { state } = useContext(AuthContext); */

  const { t } = useTranslation();

  if (role === "root") {
    return (
      <Nav className="flex-column main-menu" as="ul">
        <Nav.Item as="li" className="center">
          <Image src={Logo} />
        </Nav.Item>

        <Nav.Item as="li">
          <NavLink className="nav-link" to={"/"}>
            <FaHome className="dashboard-icon" />
            Dashboard
          </NavLink>
        </Nav.Item>

        <Nav.Item as="li">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <FaPuzzlePiece />
                {t("Menu.Competencias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/behaviors"}>
                      {t("Menu.Comportamientos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/behaviors/competencies"}
                    >
                      {t("Menu.Competencias")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/behaviors/competencies/scales"}
                    >
                      {t("Menu.Escalas")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FaChalkboardTeacher />
                {t("Menu.PlanesDesarrollo")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/trainings/training-status"}
                    >
                      {t("Menu.Avances")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/trainings/training-groups"}
                    >
                      {t("Menu.Grupos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/trainings/map"}>
                      {t("Menu.Mapa")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/trainings"}>
                      {t("Menu.Capacitaciones")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/trainings/requests"}>
                      {t("Menu.Solicitudes")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/trainings/dnc"}>
                      {t("Menu.DNC")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <FaCubes />
                {t("Menu.Perfiles")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/profiles"}>
                      {t("Menu.CatalogoPerfiles")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaTags />
                {t("Menu.Categorias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/categories"}>
                      {t("Menu.CatalogoCategorias")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                {" "}
                <FaUsers />
                {t("Menu.Personas")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/people"}>
                      {t("Menu.ListadoPersonas")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/orgchart"}>
                      {t("Menu.Organigrama")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <FaEdit />
                {t("Menu.Cuestionarios")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/questionnaires"}>
                      {t("Menu.CatalogoCuestionarios")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/questionnaires/optionsets"}
                    >
                      {t("Menu.SetsOpciones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <FaCheckSquare />
                {t("Menu.Evaluaciones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/evaluations"}>
                      {t("Menu.ListadoEvaluaciones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <FaBullseye />
                {t("Menu.Objetivos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/objectives"}>
                      {t("Menu.ListadoObjetivos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/myobjectives"}>
                      {t("Menu.MisObjetivos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/objectives/performance-review"}
                    >
                      {t("Menu.ConsultaResultados")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <FaTrafficLight />
                {t("Menu.Indicadores")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/indicators"}>
                      {t("Menu.ListadoIndicadores")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/myindicators"}>
                      {t("Menu.MisIndicadores")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink
                      className="nav-link"
                      to={"/indicators/performance-review"}
                    >
                      {t("Menu.ConsultaResultados")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>
                <FaUserFriends />
                {t("Menu.Reuniones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/meetings"}>
                      {t("Menu.ReunionesPersonales")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
              <Accordion.Header>
                <FaHandsHelping />
                {t("Menu.Compromisos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/commitments"}>
                      {t("Menu.CompromisosPersonal")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9">
              <Accordion.Header>
                <FaAward />
                {t("Menu.Reconocimientos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises"}>
                      {t("Menu.ListadoReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/values"}>
                      {t("Menu.ListadoValores")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises/leaderboard"}>
                      {t("Menu.RankingReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <FaChartBar />
                {t("Menu.Reportes")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/reports"}>
                      {t("Menu.ListadoReportes")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="11">
              <Accordion.Header>
                {" "}
                <FaFootballBall />
                {t("Menu.Hobbies")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/hobbies"}>
                      {t("Menu.ListadoHobbies")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/hobbies/search"}>
                      {t("Menu.BusquedaHobbies")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="12">
              <Accordion.Header>
                <FaBuilding />
                {t("Menu.Organizaciones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/organizations"}>
                      {t("Menu.ListadoOrganizaciones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="13">
              <Accordion.Header>
                {" "}
                <FaBriefcase />
                {t("Menu.Cuentas")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/accounts"}>
                      {t("Menu.ListadoCuentas")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Nav.Item>
      </Nav>
    );
  } else if (role === "owner") {
    return (
      <Nav className="flex-column main-menu" as="ul">
        <Nav.Item as="li" className="center">
          <Image src={Logo} />
        </Nav.Item>

        <Nav.Item as="li">
          <NavLink className="nav-link" to={"/"}>
            <FaHome />
            Dashboard
          </NavLink>
        </Nav.Item>

        <Nav.Item as="li">
          <Accordion>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <FaUsers />
                {t("Menu.Personas")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/people"}>
                      {t("Menu.ListadoPersonas")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/orgchart"}>
                      {t("Menu.Organigrama")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaTags />
                {t("Menu.Categorias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/categories"}>
                      {t("Menu.CatalogoCategorias")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>
                <FaUserFriends />
                {t("Menu.Reuniones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/meetings"}>
                      {t("Menu.ReunionesPersonales")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mymeetings"}>
                      {t("Menu.MisReuniones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8">
              <Accordion.Header>
                <FaHandsHelping />
                {t("Menu.Compromisos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/commitments"}>
                      {t("Menu.CompromisosPersonal")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mycommitments"}>
                      {t("Menu.MisCompromisos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9">
              <Accordion.Header>
                <FaAward />
                {t("Menu.Reconocimientos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises"}>
                      {t("Menu.ListadoReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/values"}>
                      {t("Menu.ListadoValores")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises/leaderboard"}>
                      {t("Menu.RankingReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="11">
              <Accordion.Header>
                {" "}
                <FaFootballBall />
                {t("Menu.Hobbies")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/hobbies/search"}>
                      {t("Menu.BusquedaHobbies")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <FaChartBar />
                {t("Menu.Reportes")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/reports"}>
                      {t("Menu.ListadoReportes")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <FaBullseye />
                {t("Menu.Objetivos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoObjetivos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/objectives"}>
                        {t("Menu.ListadoObjetivos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisObjetivos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myobjectives"}>
                        {t("Menu.MisObjetivos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/objectives/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <FaTrafficLight />
                {t("Menu.Indicadores")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoIndicadores")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/indicators"}>
                        {t("Menu.ListadoIndicadores")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisIndicadores")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myindicators"}>
                        {t("Menu.MisIndicadores")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/indicators/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <FaPuzzlePiece />
                {t("Menu.Competencias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Comportamientos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/behaviors"}>
                        {t("Menu.Comportamientos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Competencias")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/behaviors/competencies"}
                      >
                        {t("Menu.Competencias")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Escalas")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/behaviors/competencies/scales"}
                      >
                        {t("Menu.Escalas")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <FaCubes />
                {t("Menu.Perfiles")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.CatalogoPerfiles")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/profiles"}>
                        {t("Menu.CatalogoPerfiles")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>
                {" "}
                <FaEdit />
                {t("Menu.Cuestionarios")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.CatalogoCuestionarios")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/questionnaires"}>
                        {t("Menu.CatalogoCuestionarios")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.SetsOpciones")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/questionnaires/optionsets"}
                      >
                        {t("Menu.SetsOpciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <FaCheckSquare />
                {t("Menu.Evaluaciones")}
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoEvaluaciones")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/evaluations"}>
                        {t("Menu.ListadoEvaluaciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FaChalkboardTeacher />
                {t("Menu.PlanesDesarrollo")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Avances")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/trainings/training-status"}
                      >
                        {t("Menu.Avances")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Grupos")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/trainings/training-groups"}
                      >
                        {t("Menu.Grupos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Mapa")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/map"}>
                        {t("Menu.Mapa")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Capacitaciones")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings"}>
                        {t("Menu.Capacitaciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Solicitudes")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/requests"}>
                        {t("Menu.Solicitudes")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.DNC")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/dnc"}>
                        {t("Menu.DNC")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="12">
              <Accordion.Header>
                <FaBuilding />
                {t("Menu.Organizaciones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/organizations"}>
                      {t("Menu.ListadoOrganizaciones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Nav.Item>
      </Nav>
    );
  } else if (role === "admin") {
    return (
      <Nav className="flex-column main-menu" as="ul">
        <Nav.Item as="li" className="center">
          <Image src={Logo} />
        </Nav.Item>

        <Nav.Item as="li">
          <NavLink className="nav-link" reloadDocument to={"/"}>
            <FaHome />
            Dashboard
          </NavLink>
        </Nav.Item>

        <Nav.Item as="li">
          <Accordion>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <FaUsers />
                {t("Menu.Personas")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/people"}>
                      {t("Menu.ListadoPersonas")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/orgchart"}>
                      {t("Menu.Organigrama")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaTags />
                {t("Menu.Categorias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/categories"}>
                      {t("Menu.CatalogoCategorias")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>
                <FaUserFriends />
                {t("Menu.Reuniones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/meetings"}>
                      {t("Menu.ReunionesPersonales")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mymeetings"}>
                      {t("Menu.MisReuniones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8">
              <Accordion.Header>
                <FaHandsHelping />
                {t("Menu.Compromisos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/commitments"}>
                      {t("Menu.CompromisosPersonal")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mycommitments"}>
                      {t("Menu.MisCompromisos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9">
              <Accordion.Header>
                <FaAward />
                {t("Menu.Reconocimientos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises"}>
                      {t("Menu.ListadoReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/values"}>
                      {t("Menu.ListadoValores")}
                    </NavLink>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises/leaderboard"}>
                      {t("Menu.RankingReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="11">
              <Accordion.Header>
                {" "}
                <FaFootballBall />
                {t("Menu.Hobbies")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/hobbies/search"}>
                      {t("Menu.BusquedaHobbies")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10">
              <Accordion.Header>
                <FaChartBar />
                {t("Menu.Reportes")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/reports"}>
                      {t("Menu.ListadoReportes")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <FaBullseye />
                {t("Menu.Objetivos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoObjetivos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/objectives"}>
                        {t("Menu.ListadoObjetivos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisObjetivos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myobjectives"}>
                        {t("Menu.MisObjetivos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/objectives/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <FaTrafficLight />
                {t("Menu.Indicadores")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoIndicadores")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/indicators"}>
                        {t("Menu.ListadoIndicadores")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisIndicadores")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myindicators"}>
                        {t("Menu.MisIndicadores")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/indicators/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <FaPuzzlePiece />
                {t("Menu.Competencias")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Comportamientos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/behaviors"}>
                        {t("Menu.Comportamientos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Competencias")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/behaviors/competencies"}
                      >
                        {t("Menu.Competencias")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Escalas")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/behaviors/competencies/scales"}
                      >
                        {t("Menu.Escalas")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <FaCubes />
                {t("Menu.Perfiles")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.CatalogoPerfiles")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/profiles"}>
                        {t("Menu.CatalogoPerfiles")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>
                <FaEdit />
                {t("Menu.Cuestionarios")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.CatalogoCuestionarios")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/questionnaires"}>
                        {t("Menu.CatalogoCuestionarios")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.SetsOpciones")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/questionnaires/optionsets"}
                      >
                        {t("Menu.SetsOpciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                <FaCheckSquare />
                {t("Menu.Evaluaciones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false &&
                    strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ListadoEvaluaciones")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/evaluations"}>
                        {t("Menu.ListadoEvaluaciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FaChalkboardTeacher />
                {t("Menu.PlanesDesarrollo")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Avances")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/trainings/training-status"}
                      >
                        {t("Menu.Avances")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Grupos")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/trainings/training-groups"}
                      >
                        {t("Menu.Grupos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Mapa")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/map"}>
                        {t("Menu.Mapa")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Capacitaciones")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings"}>
                        {t("Menu.Capacitaciones")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Solicitudes")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/requests"}>
                        {t("Menu.Solicitudes")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.DNC")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/dnc"}>
                        {t("Menu.DNC")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Nav.Item>
      </Nav>
    );
  } else {
    return (
      <Nav className="flex-column main-menu" as="ul">
        <Nav.Item as="li" className="center">
          <Image src={Logo} />
        </Nav.Item>

        <Nav.Item as="li">
          <NavLink className="nav-link" reloadDocument to={"/"}>
            <FaHome />
            Dashboard
          </NavLink>
        </Nav.Item>

        <Nav.Item as="li">
          <Accordion>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <FaUserFriends />
                {t("Menu.Reuniones")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mymeetings"}>
                      {t("Menu.MisReuniones")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <FaHandsHelping />
                {t("Menu.Compromisos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/mycommitments"}>
                      {t("Menu.MisCompromisos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                <FaAward />
                {t("Menu.Reconocimientos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/praises"}>
                      {t("Menu.ListadoReconocimientos")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="11">
              <Accordion.Header>
                {" "}
                <FaFootballBall />
                {t("Menu.Hobbies")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/hobbies/search"}>
                      {t("Menu.BusquedaHobbies")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                <FaChartBar />
                {t("Menu.Reportes")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    <NavLink className="nav-link" to={"/reports"}>
                      {t("Menu.ListadoReportes")}
                    </NavLink>
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="14">
              <Accordion.Header>
                <FaBullseye />
                {t("Menu.Objetivos")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisObjetivos")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myobjectives"}>
                        {t("Menu.MisObjetivos")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/objectives/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="15">
              <Accordion.Header>
                <FaTrafficLight />
                {t("Menu.Indicadores")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.MisIndicadores")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/myindicators"}>
                        {t("Menu.MisIndicadores")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {performancePackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.ConsultaResultados")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/indicators/performance-review"}
                      >
                        {t("Menu.ConsultaResultados")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <FaChalkboardTeacher />
                {t("Menu.PlanesDesarrollo")}
              </Accordion.Header>
              <Accordion.Body>
                <Nav className="flex-column sub-menu" as="ul">
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Avances")}
                      </p>
                    ) : (
                      <NavLink
                        className="nav-link"
                        to={"/trainings/training-status"}
                      >
                        {t("Menu.Avances")}
                      </NavLink>
                    )}
                  </Nav.Item>
                  <Nav.Item as="li">
                    {strategyPackage === false ? (
                      <p className="disabled-link">
                        <FaLock /> {t("Menu.Solicitudes")}
                      </p>
                    ) : (
                      <NavLink className="nav-link" to={"/trainings/requests"}>
                        {t("Menu.Solicitudes")}
                      </NavLink>
                    )}
                  </Nav.Item>
                </Nav>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Nav.Item>
      </Nav>
    );
  }
}

export default MainMenu;
